<template>
  <div>
    <div>
      <div id="modal1" class="modal bottom-sheet">
        <div class="modal-content">
          <span class="modal-info-text">Select a child to switch to their account.</span>
          <transition name="fade" mode="out-in">
            <center>
              <div
                v-long-press="500"
                v-for="(kid, index) in $root.$data.kids"
                class="headWrapper"
                @click="hideModal(true)"
                @long-press-start="removeChild(this, index)"
                :updater="$root.$data.kids"
                :key="'heads_' + index"
              >
                <UserHead :kid="kid" :index="index"></UserHead>
              </div>
              <div class="headWrapper" @click="hideModal(true)">
                <UserHead isAddChild="true"></UserHead>
              </div>
            </center>
          </transition>
        </div>
      </div>
      <div id="addChoreModal" class="modal bottom-sheet" enterkeyhint="enter">
        <div class="modal-content">
          <center>
            <div class="modal-header">
              <h5 class="selected">{{ $t("components.modal.addChore") }}</h5>
            </div>
            <div style="padding: 10px">
              <div class="row">
                <div class="titleAndMile">
                  <input
                    required
                    v-model="chore.title"
                    :placeholder="$t('components.modal.taskName')"
                    autocomplete="off"
                    class="choretitle"
                    name="taskName"
                  />
                  <div>
                    <input
                      id="points"
                      name="points"
                      required
                      autocomplete="off"
                      type="number"
                      pattern="[0-9]*"
                      min="0"
                      max="9999"
                      v-model="chore.points"
                      :placeholder="$t('components.modal.points')"
                    />
                  </div>
                </div>
                <p>{{ $t("components.modal.selectChild") }}</p>
                <select name="child" required v-model="$root.$data.selectedChild">
                  <option
                    v-for="(kid, i) in $root.$data.kids"
                    :value="i"
                    :key="`cn${i}`"
                    :updater="$root.$data.kids"
                  >{{ kid.get("name") }}</option>
                </select>
                <div>
                  <div class="rap">
                    <p v-if="!showRepeating">{{ $t("components.modal.repeat") }}</p>
                    <div v-else>
                      <input
                        v-show="showRepeating"
                        type="checkbox"
                        class="form-radio"
                        v-for="(day, index) of daysInWeek"
                        :key="day"
                        :id="day"
                        :data-dayOfWeek="isChinese ? day : day[0]"
                        :title="day.capitalize()"
                        v-on:click="addDayToRepeat(index)"
                      />
                    </div>
                    <div class="wrapper">
                      <input
                        type="checkbox"
                        name="toggle"
                        role="switch"
                        id="toggle"
                        aria-label="Repeat"
                        v-model="showRepeating"
                        style="display: none"
                      />
                      <label for="toggle"></label>
                    </div>
                  </div>
                </div>
                <button
                  class="btn btn-wide"
                  @click="addChore()"
                >{{ $t("components.modal.addChoreButton") }}</button>
              </div>
            </div>
          </center>
        </div>
      </div>
      <div id="editChoreModal" class="modal bottom-sheet">
        <div class="modal-content">
          <center>
            <div class="modal-header">
              <h5 class="selected">{{ $t("components.modal.addChore") }}</h5>
            </div>
            <div style="padding: 10px">
              <div class="row">
                <div class="titleAndMile">
                  <input
                    required
                    v-model="chore.title"
                    :placeholder="$t('components.modal.taskName')"
                    autocomplete="off"
                    class="choretitle"
                    name="taskName"
                  />
                  <div>
                    <input
                      id="points"
                      name="points"
                      required
                      autocomplete="off"
                      type="number"
                      pattern="[0-9]*"
                      min="0"
                      max="9999"
                      v-model="chore.points"
                      :placeholder="$t('components.modal.points')"
                    />
                  </div>
                </div>
                <p>{{ $t("components.modal.selectChild") }}</p>
                <select name="child" required v-model="$root.$data.selectedChild">
                  <option
                    v-for="(kid, i) in $root.$data.kids"
                    :value="i"
                    :key="`cn${i}`"
                    :updater="$root.$data.kids"
                  >{{ kid.get("name") }}</option>
                </select>
                <div>
                  <div class="rap">
                    <p v-if="!showRepeating">{{ $t("components.modal.repeat") }}</p>
                    <div v-else>
                      <input
                        v-show="showRepeating"
                        type="checkbox"
                        class="form-radio"
                        v-for="(day, index) of daysInWeek"
                        :key="day"
                        :id="day"
                        :data-dayOfWeek="isChinese ? day : day[0]"
                        :title="day.capitalize()"
                        v-on:click="addDayToRepeat(index)"
                      />
                    </div>
                    <div class="wrapper">
                      <input
                        type="checkbox"
                        name="toggle"
                        role="switch"
                        id="toggle"
                        aria-label="Repeat"
                        v-model="showRepeating"
                        style="display: none"
                      />
                      <label for="toggle"></label>
                    </div>
                  </div>
                </div>
                <button
                  class="btn btn-wide"
                  @click="addChore()"
                >{{ $t("components.modal.addChoreButton") }}</button>
              </div>
            </div>
          </center>
        </div>
      </div>
      <div id="modal3" class="modal bottom-sheet">
        <div class="modal-content">
          <center>
            <div class="modal-header">
              <h5 class="selected">{{ $t("components.modal.addReward") }}</h5>
            </div>
            <div style="padding: 10px">
              <div class="row">
                <div class="titleAndMile">
                  <input
                    required
                    v-model="reward.name"
                    :placeholder="$t('components.modal.rewardName')"
                    autocomplete="off"
                    class="choretitle"
                    name="taskName"
                  />
                  <div>
                    <input
                      id="points"
                      name="points"
                      required
                      autocomplete="off"
                      type="number"
                      pattern="[0-9]*"
                      min="0"
                      max="9999"
                      v-model="reward.points"
                      :placeholder="$t('components.modal.points')"
                    />
                  </div>
                </div>
                <p>{{ $t("components.modal.selectChild") }}</p>
                <select name="child" required v-model="$root.$data.selectedChild">
                  <option
                    v-for="(kid, i) in $root.$data.kids"
                    :value="i"
                    :key="`cn${i}`"
                    :updater="$root.$data.kids"
                  >{{ kid.get("name") }}</option>
                </select>
                <button
                  class="btn btn-wide"
                  @click="addReward()"
                >{{ $t("components.modal.addRewardButton") }}</button>
              </div>
            </div>
          </center>
        </div>
      </div>
      <div id="AddSuggestedRewardModal" class="modal bottom-sheet">
        <div class="modal-content">
          <center>
            <div class="modal-header" style="grid-template-columns: 1fr">
              <span></span>

              <h5 class="selected">{{ $t("components.modal.addReward") }}</h5>
              <span></span>
            </div>
            <div style="padding: 10px">
              <div class="row">
                <span></span>
                <p>{{ $t("components.modal.selectChild") }}</p>

                <div style="padding: 10px">
                  <div class="row">
                    <div class="titleAndMile">
                      <select name="child" required v-model="$root.$data.selectedChild">
                        <option
                          v-for="(kid, i) in $root.$data.kids"
                          :value="i"
                          :key="`cn${i}`"
                          :updater="$root.$data.kids"
                        >{{ kid.get("name") }}</option>
                      </select>
                      <div>
                        <input
                          id="points"
                          name="points"
                          required
                          autocomplete="off"
                          type="number"
                          pattern="[0-9]*"
                          min="0"
                          max="9999"
                          v-model="reward.points"
                          :placeholder="$t('components.modal.points')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <button
                  class="btn btn-wide"
                  @click="addSuggestedReward()"
                >{{ $t("components.modal.addRewardButton") }}</button>
              </div>
            </div>
          </center>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as CCDb from "@/utilities/db.js";
import * as ModernModals from "modern-modals";
import LongPress from "vue-directive-long-press";

export default {
  name: "modal",
  components: {
    UserHead: () => import("../Head.vue")
  },
  directives: {
    "long-press": LongPress
  },
  data() {
    return {
      isChinese: false,
      renderComponent: true,
      addChildKid: {
        name: this.$t("components.modal.addChild"),
        id: "new",
        image:
          "data:image/png;base64,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"
      },
      reward: {
        name: ""
      },
      chore: {
        title: "",
        points: null,
        done: false,
        image: "",
        repeats: "0.0.0.0.0.0.0"
      },
      showRepeating: false,
      daysInWeek: this.$t("generic.daysOfWeek").split("~"),
      activeCategory: {
        age: null,
        category: null
      },
      dueDate: null
    };
  },
  mounted() {
    this.$data.isChinese = $("html")
      .attr("lang")
      .includes("zh");
    window.ChildSelectorModal = new ModernModals.HTMLModal($_("modal1"));
    window.AddChoreModal = new ModernModals.HTMLModal($_("addChoreModal"));
    window.AddRewardModal = new ModernModals.HTMLModal($_("modal3"));

    setTimeout(() => AddChoreModal.close(), 100);
    const pointsElem = $("[name=points]");
    pointsElem.addEventListener("input", e => {
      pointsElem.value = pointsElem.value.replace(/\D/g, "");
      if (Number(pointsElem.value) >= 9999) {
        pointsElem.value = pointsElem.value.substr(0, 4);
      }
    });
  },
  methods: {
    openAddChore() {
      window.AddChoreModal.open();
    },
    hideModal() {
      window.ChildSelectorModal.isOpen
        ? window.ChildSelectorModal.close()
        : null;
      window.AddChoreModal.isOpen ? window.AddChoreModal.close() : null;
    },
    async removeChild(e, id) {
      let confirm = await ModernModals.prompt(
        "Delete Child",
        `Do you want to delete ${this.$root.$data.kids[id].get("name")}?`
      );
      if (confirm) {
        this.$root.kids[id].destroy().then(async () => {
          await this.$root.initLoadChores();
          this.hideModal();
          this.$root.$data.selectedChild =
            this.$root.$data.kids.length - 2 <= 0
              ? 0
              : this.$root.$data.kids.length - 2;
        });
      }
    },
    addDayToRepeat(day) {
      const element = $_(this.$data.daysInWeek[day]);
      switch (day) {
        case 0:
          day = 0;
          break;
        default:
          day = day * 2;
          break;
      }
      this.$data.chore.repeats =
        this.$data.chore.repeats.substr(0, day) +
        (element.checked | 0) +
        this.$data.chore.repeats.substr(day + 1);
    },
    async addReward() {
      if (this.$data.reward.name.length <= 0) {
        await AddRewardModal.close();
        await ModernModals.alert("Uh oh!", "Please name your reward!");
        AddRewardModal.open();
        return;
      }
      if (
        this.$data.reward.points == null ||
        this.$data.reward.points == 0 ||
        this.$data.reward.points == "0" ||
        this.$data.reward.points == ""
      ) {
        await AddRewardModal.close();
        await ModernModals.alert("Uh oh!", "Please enter a point value!");
        AddRewardModal.open();
        return;
      }
      const reward = await CCDb.createRecord("customRewards", {
        name: this.$data.reward.name,
        ownerId: CCDb.currentUser().uid,
        createdAt: Date.now()
      });
      VueInstance.$data.kids[VueInstance.$data.selectedChild].set(
        "customReward",
        reward
      );
      VueInstance.$data.kids[VueInstance.$data.selectedChild].set(
        "rewardValue",
        Number(this.$data.reward.points)
      );
      await VueInstance.$data.kids[VueInstance.$data.selectedChild].save();
      await VueInstance.initLoadChores();
      await VueInstance.$children[0].$children.forEach(x => x.$forceUpdate());
      window.location.href = "/#/rewards";
      setTimeout(() => (window.location.href = "/#/"), 95);

      VueInstance.initLoadChores();
      AddRewardModal.close();
      this.$data.reward.points = null;
      this.$data.reward.name = "";
    },
    async addChore() {
      if (this.$data.chore.title.length <= 0) {
        await AddChoreModal.close();
        await ModernModals.alert("Uh oh!", "Please name your chore!");
        AddChoreModal.open();
        return;
      }
      if (this.$data.chore.points < 0) {
        this.$data.chore.points = 0;
        await AddChoreModal.close();
        await ModernModals.alert(
          "Uh oh!",
          "Please choose a point value greater than or equal to 0!"
        );
        AddChoreModal.open();
        return;
      }
      gtag("event", "add_chore", {
        event_category: "engagement"
      });
      const kid = VueInstance.$data.kids[VueInstance.$data.selectedChild];
      if (!kid) {
        await ModernModals.alert(
          "Uh oh!",
          "Add a child to your family before adding a chore!"
        );
        return;
      }
      const data = this.$data;
      this.hideModal();
      await CCDb.addChore(kid, data.chore);
      await this.$root.loadChores();
      VueInstance.$children[0].$children.forEach(x => x.$forceUpdate());
      this.$data.chore = {
        title: "",
        points: 0,
        done: false,
        image: "",
        repeats: "0.0.0.0.0.0.0"
      };
      this.$data.showRepeating = false;
    },
    async addSuggestedReward() {
      let currentReward = this.$root.$data.currentReward;
      const reward = await CCDb.createRecord("customRewards", {
        name: currentReward.get("name"),
        ownerId: CCDb.currentUser().uid,
        createdAt: Date.now()
      });
      VueInstance.$data.kids[this.$root.$data.selectedChild].set(
        "customReward",
        reward
      );
      VueInstance.$data.kids[this.$root.$data.selectedChild].set(
        "rewardValue",
        Number(this.$data.reward.points)
      );
      await VueInstance.$data.kids[this.$root.$data.selectedChild].save();
      await VueInstance.initLoadChores();
      setTimeout(() => (window.location.href = "/#/"), 95);
      VueInstance.initLoadChores();
      window.suggestedRewardModal.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 200;
  padding: 10px;
  margin: var(--modal-and-tabbar-margin);
  border-radius: var(--modal-radius);
  transform: translateY(100vh);
  will-change: transform;
  transition: all 0.3s ease-in-out;
  background-color: var(--modal-bg);
  pointer-events: none;
  height: fit-content;
  max-height: var(--modal-max-height);
  &:focus {
    outline: none;
  }

  &-overlay {
    transition: all 0.3s ease-in-out;
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 300;
    height: 125%;
    width: 100%;
    // opacity: 0;
    pointer-events: none;
  }
  &-header {
    display: grid;
    grid-template-columns: 1fr;
  }
  &-content {
    overflow: hidden;
    center {
      max-height: 50ch;
      // overflow: scroll;
    }
  }
}

.titleAndMile {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 3fr 1fr;
  div,
  input {
    margin: 0;
    width: 100%;
  }
}

input::-webkit-inner-spin-button,
input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.distWrapper {
  display: inline-block;
  position: relative;
  margin-top: 10px;
}

#addChoreModal {
  .modal-content {
    margin: auto;
    max-width: 700px;
    text-align: center;
  }
  h5 {
    color: var(--layout-color);
  }
  .dropdown-trigger {
    width: 100% !important;
  }
  .wrapper {
    max-width: 300px;
    display: inline;
    text-align: right;
  }

  .rap {
    display: grid;
    padding: 10px;
    height: min-content;
    height: 50px;
    grid-template-columns: 1fr auto;
    grid-template-rows: 1fr;
    p {
      text-align: left;
      margin: 0;
      margin-top: 7.5px;
    }
  }

  .form-radio {
    top: 0;
    width: calc(100% / 9);
  }

  [type="checkbox"]:not(:checked),
  [type="checkbox"]:checked {
    position: initial;
    opacity: 1;
    pointer-events: initial;
  }
  [type="checkbox"]:checked {
    background: var(--theme-color);
    &:after {
      color: white !important;
    }
    font-weight: 400;
  }
  input:before {
    content: none !important;
  }
  input {
    display: true;
  }
  input:after {
    display: block;
    line-height: 30px;
    width: 100%;
    height: 30px;
    content: attr(data-dayOfWeek);
    color: inherit;
    text-transform: uppercase;
    color: var(--layout-color);
  }
  p {
    color: var(--layout-color);
    padding-bottom: 3px;
  }
}

.selected {
  background: var(--theme-color);
  filter: var(--selected-tab-brightness);
  -webkit-text-fill-color: transparent !important;
  -webkit-background-clip: text !important;
}
#modal3 [name="child"] {
  margin-bottom: calc(0.656rem + 10px);
}
</style>
